"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var classNames = require("classnames");
var PropTypes = require("prop-types");
var React = require("react");
var react_1 = require("react");
var propTypes = {
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.bool]).isRequired,
    label: PropTypes.oneOfType([PropTypes.string, PropTypes.element]).isRequired,
    colorScheme: PropTypes.oneOf(['regular', 'inverted']),
    error: PropTypes.bool
};
/**
 * A `Radio` component is a wrapper around the native HTML input element with
 * type `radio`.
 * The component is often used in the context of a
 * [`RadioGroupRow`](#!/RadioGroupRow).
 */
var Radio = /** @class */ (function (_super) {
    __extends(Radio, _super);
    function Radio() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Radio.prototype.render = function () {
        var _a = this.props, children = _a.children, id = _a.id, className = _a.className, error = _a.error, label = _a.label, colorScheme = _a.colorScheme, onChange = _a.onChange, value = _a.value, dataComponentId = _a["data-component-id"], other = __rest(_a, ["children", "id", "className", "error", "label", "colorScheme", "onChange", "value", 'data-component-id']);
        var componentClassName = classNames(className, 'ee_radio', "ee_radio--" + colorScheme, {
            'ee_is-invalid': error
        });
        return (React.createElement("label", { className: componentClassName, "data-component-id": dataComponentId },
            React.createElement("input", __assign({ "data-focus-id": id }, other, { id: id, type: "radio", className: classNames('ee_radio__control', "ee_radio__control--" + colorScheme), value: String(value), "aria-invalid": error, onChange: onChange })),
            React.createElement("span", { className: classNames('ee_radio__label', "ee_radio__label--" + colorScheme) }, label)));
    };
    Radio.propTypes = propTypes;
    Radio.defaultProps = {
        error: false,
        value: undefined,
        label: undefined,
        colorScheme: 'regular',
        onChange: function () {
            /* intentionally empty */
        }
    };
    return Radio;
}(react_1.Component));
exports.Radio = Radio;
exports.default = Radio;
//# sourceMappingURL=Radio.js.map